<template>
  <div class="content_menu clearfix">
    <div class="left" style="width:343px">
      <div class="left" style="width:178px;">
        <TheFoodMenu active="burgerbowls" />
      </div>

      <div class="left" style="margin:-13px 0 0 27px;">
        <img src="/assets/images/titles/menu_left_burgers.png">
      </div>

      <br clear="all">

      <div class="left" style="margin:-10px 0 0 25px;">
        <img src="/assets/images/Menu_burgers_womensleeping.png">
      </div>

    </div>

    <div class="right" style="width:552px; margin:8px 0px 0 0;">
      <div class="menu_right">
        <div class="menu_name" style="margin-bottom:-5px;">
          <img src="/assets/images/menu_img/menu_burgers_customize.png" />
        </div>

        <div class="menu_name">
          Patties
        </div>

        <div class="menu_option">
          <ul>
            <li>
              Hamburger <br/>
              <span>(USDA Choice Angus Beef-ground daily at Jeffrey&#8217;s)</span>
            </li>
            <li>Turkey burger &nbsp;</li>
            <li>Garden burger &nbsp;</li>
          </ul>
        </div>

        <div class="menu_name">
          CHEESE
        </div>

        <div class="menu_option">
          <ul>
            <li>American, Swiss, Cheddar, Blue,  Jack &amp; Pepper Jack</li>
          </ul>
        </div>
      </div>

      <div class="product-container">
        <ProductList :products="products" />
      </div>
    </div>
  </div>
</template>

<script>
import TheFoodMenu from '@/components/TheFoodMenu.vue';
import ProductList from '@/components/ProductList.vue';

export default {
  name: 'BurgerBowls',

  components: {
    TheFoodMenu,
    ProductList,
  },

  data() {
    return {
      products: [
        {
          id: 1,
          name: 'HAMBURGER BOWL',
          description: 'Burger Patty over Spring Mix Greens Tossed in Lemon Vinaigrette with Carrots, Cucumbers, Tomato and Red Onion topped with Crispy Onion Strings',
          modifiers: [],
        },
        {
          id: 2,
          name: 'CHEESEBURGER BOWL',
          description: 'Served with Your Choice of Cheese',
          modifiers: [],
        },
        {
          id: 3,
          name: 'DOUBLE HAMBURGER BOWL',
          description: 'Two Patties',
          modifiers: [],
        },
        {
          id: 4,
          name: 'DOUBLE CHEESEBURGER BOWL',
          description: 'Two Patties & Double Cheese',
          modifiers: [],
        },
        {
          id: 5,
          name: 'BACON BURGER BOWL',
          description: 'Hardwood Smoked, Honey-Cured Bacon',
          modifiers: [],
        },
        {
          id: 6,
          name: 'BACON CHEESEBURGER BOWL',
          description: 'Hardwood Smoked, Honey-Cured Bacon & Cheese',
          modifiers: [],
        },
        {
          id: 7,
          name: 'MUSHROOM BURGER BOWL',
          description: 'Topped with Mushrooms Sauteed with Garlic and Soy Sauce',
          modifiers: [],
        },
        {
          id: 8,
          name: 'AVOCADO BURGER BOWL',
          description: 'Topped with Fresh Avocado Slices',
          modifiers: [],
        },
        {
          id: 9,
          name: 'PINEAPPLE TERIYAKI BURGER BOWL',
          description: 'Cooked in Teriyaki Sauce & Topped with a Grilled Slice of Pineapple',
          modifiers: [],
        },
        {
          id: 10,
          name: 'CHICKEN BREAST BOWL',
          description: 'Grilled Garlic Herb Chicken Breast',
          modifiers: [],
        },
        {
          id: 11,
          name: 'TUNA SALAD BOWL',
          description: '',
          modifiers: [],
        },
      ],
    };
  },
};
</script>
